export function getIsHomePage() {
  return location.pathname === "" || location.pathname === "/";
}

export function getPageCategory() {
  // <body data-category="apartment">
  // <body data-category="parking">
  const ele = document.querySelector<HTMLElement>("[data-category]");
  if (!ele) return "";
  return ele.dataset.category;
}
